import { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import useLookupCurrency from '../../../../hooks/Lookups/use-Lookup-Currency';
import { FormPayrollElement } from '../../../ValidationForm/validationSchema';
import {
  cleanElementTypeListById,
  GetClassification,
  GetElementTypeById,
  UpdateElementType
} from '../../../../store/HR/Payroll/payrollElementSlice';
import { useNavigate } from 'react-router-dom';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import Loading from '../../../../components/Shared/Loader/Loading';

function EditElementType({ id }) {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { Currency } = useLookupCurrency();
  const { ClassificationList, ElementTypeListById, loading3, error } = useSelector(
    state => state.PyrollElement
  );
  const { ElementTypeList } = useSelector(state => state.PyrollElement);
  const existingCodes = ElementTypeList.map(item => item.code);

  useEffect(() => {
    dispatch(cleanElementTypeListById());
    dispatch(GetElementTypeById(id));
    // dispatch(GetClassification());
  }, [dispatch, id]);

  const formik = useFormik({
    initialValues: {
      name: ElementTypeListById ? ElementTypeListById.name : '',
      name2: ElementTypeListById ? ElementTypeListById.name2 : '',
      currencyCode: ElementTypeListById ? ElementTypeListById.currencyCode : '',
      classificationId: ElementTypeListById ? ElementTypeListById.classificationId : '',
      description: ElementTypeListById ? ElementTypeListById.description : '',
      isRecurring: ElementTypeListById ? ElementTypeListById.isRecurring : false,
      uom: ElementTypeListById ? ElementTypeListById.uom : '',

      priority: ElementTypeListById ? ElementTypeListById.priority : '',
      formula: '',
      code: ElementTypeListById ? ElementTypeListById.code : ''
    },
    enableReinitialize: true,
    validationSchema: FormPayrollElement(t, existingCodes),
    onSubmit: values => {
      dispatch(
        UpdateElementType({
          id: id,
          name: values.name,
          name2: values.name2,
          currencyCode: values.currencyCode,
          classificationId: values.classificationId, // values.classificationId
          description: values.description,
          isRecurring: values.isRecurring,
          uom: values.uom,

          priority: values.priority,
          // formula: '',
          code: values.code
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Edit' });
        })
        .catch(error => {
          CustomAlert({ action: 'Info' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  return (
    <>
      <Loading loading={loading3} error={error}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row'>
            {/* LocalName */}
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('LocalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name2'
                  onChange={formik.handleChange}
                  value={formik.values.name2 || ''}
                  isInvalid={formik.touched.name2 && formik.errors.name2}
                />
                <Form.Control.Feedback type='invalid'>
                  {/* {formik.errors.NATIONAL_IDENTIFIER} */}
                </Form.Control.Feedback>
              </div>
            </div>

            {/* GlobalName */}
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('GlobalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name'
                  onChange={formik.handleChange}
                  value={formik.values.name || ''}
                  isInvalid={formik.touched.name && formik.errors.name}
                />
                <Form.Control.Feedback type='invalid'>
                  {/* {formik.errors.NATIONAL_IDENTIFIER} */}
                </Form.Control.Feedback>
              </div>
            </div>

            {/* Classification */}
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Classification')}</label>
                <Form.Select
                  className='form-select'
                  name='classificationId'
                  onChange={formik.handleChange}
                  value={formik.values.classificationId}
                  isInvalid={formik.touched.classificationId && formik.errors.classificationId}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {ClassificationList?.map((item, idx) => (
                    <option key={++idx} value={item.id}>
                      {i18n.language === 'ar' ? item.name2 : item.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type='invalid'>
                  {/* {formik.errors.TITLE} */}
                </Form.Control.Feedback>
              </div>
            </div>
            {/* isRecurring */}
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                {/* <label className='form-label'>{t('Recurring')} </label> */}
                <label className='form-label'>{t('هل العنصر متكرر')} </label>
                <div className='form-control d-flex align-items-center'>
                  <Form.Check
                    // style={{ margin: '10px 20px' }}
                    className='form-check'
                    type='switch'
                    // label={t('Recurring')}
                    name='isRecurring'
                    onChange={formik.handleChange}
                    // value={formik.values.isRecurring}
                    checked={formik.values.isRecurring || false}
                  />
                </div>
              </div>
            </div>

            {/* <div className='col-xl-2'>
              <div className='form-group mb-3'>
                <label className='form-label'> </label>
                <Form.Check
                  type='switch'
                  label={t('Recurring')}
                  name='isRecurring'
                  onChange={formik.handleChange}
                  value={formik.values.isRecurring}
                  checked={formik.values.isRecurring || false}
                />
              </div>
            </div> */}

            {/* Currency */}
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Currency')}</label>
                <Form.Select
                  className='form-select'
                  name='currencyCode'
                  onChange={formik.handleChange}
                  value={formik.values.currencyCode}
                  isInvalid={formik.touched.currencyCode && formik.errors.currencyCode}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {Currency?.map(item => (
                    <option key={item.currencyCode} value={item.currencyCode}>
                      {item.description}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type='invalid'>
                  {/* {formik.errors.TITLE} */}
                </Form.Control.Feedback>
              </div>
            </div>
            {/* InputOfType */}
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('InputOfType')}</label>
                <Form.Select
                  className='form-select'
                  name='uom'
                  onChange={formik.handleChange}
                  value={formik.values.uom}
                >
                  <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

                  <option key={1} value='Text'>
                    {i18n.language === 'ar' ? 'نص' : 'Text'}
                  </option>

                  <option key={2} value='Date'>
                    {i18n.language === 'ar' ? 'تاريخ' : 'Date'}
                  </option>

                  <option key={3} value='Percentage'>
                    {i18n.language === 'ar' ? 'نسبة مئوية' : 'Percentage'}
                  </option>

                  <option key={4} value='NoBasic'>
                    {i18n.language === 'ar' ? 'عدد مرات راتب أساسي' : 'No Basic'}
                  </option>

                  <option key={5} value='Money'>
                    {i18n.language === 'ar' ? 'قيمة مالية' : 'Money'}
                  </option>

                  <option key={6} value='Number'>
                    {i18n.language === 'ar' ? 'رقم' : 'Number'}
                  </option>

                  <option key={7} value='Time'>
                    {i18n.language === 'ar' ? 'وقت' : 'Time'}
                  </option>

                  <option key={8} value='Day'>
                    {i18n.language === 'ar' ? 'يوم' : 'Day'}
                  </option>
                </Form.Select>
              </div>
            </div>
            {/* priority */}
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Priority')}</label>
                <Form.Control
                  className='form-control'
                  type='number'
                  autoComplete='off'
                  name='priority'
                  onChange={formik.handleChange}
                  value={formik.values.priority || ''}
                  isInvalid={formik.touched.priority && formik.errors.priority}
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.priority}
                </Form.Control.Feedback>
              </div>
            </div>
            {/* Code */}
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Code')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='code'
                  onChange={formik.handleChange}
                  value={formik.values.code || ''}
                  isInvalid={formik.touched.code && formik.errors.code}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.code}</Form.Control.Feedback>
              </div>
            </div>
            <div className='col-xl-9'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Note')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='description'
                  onChange={formik.handleChange}
                  value={formik.values.description || ''}
                />
              </div>
            </div>
          </div>

          <div className='text-center mt-3'>
            <div className='d-flex justify-content-between gap-2'>
              <button
                disabled={formik.isSubmitting}
                type='submit'
                className='btn btn-lg btn-theme mb-1 w-100 rounded-1'
              >
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-save fa-lg fa-fw me-2'></i>
                )}
                {t('Save')}
              </button>
              <button
                type='button'
                className='btn btn-lg  btn-default mb-1 w-100 rounded-1'
                data-bs-dismiss='modal'
                id='closeModalElement'
              >
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
      {/* </CardBody> */}
      {/* </Card> */}
    </>
  );
}

export default EditElementType;
